/* eslint-disable */
import { RegularButton } from 'pg-ui-library';
import { useParams, useNavigate } from 'react-router-dom'; // Added useNavigate import
import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from 'src/modules/login/components/mfa-modal/styles';
import closeSvg from 'src/assets/close.svg';
import { useMutation } from '@tanstack/react-query';
import LeavepageService from 'src/services/leave-page.service';

import { ReopenTicketBody, ReopenTicketHeader, ReopenFooter, ReopenQues, ReopenLabel } from './styles';

export const WithdrawModal: React.FC<{
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  leaveId: string; // Pass the leaveId to the modal
  onClose?: () => void;
  onConfirm?: () => void;
}> = ({ isOpen, setIsOpen, leaveId, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const ticketId = useParams<{ ticketId: string }>().ticketId;
  const companyId = ''; // Adjust as necessary
  const navigate = useNavigate(); // Initialize navigate

  const [isSuccess, setIsSuccess] = useState(false); // State to track success

  const {
    mutate: withdrawLeave,
    isLoading,
    isError,
    error,
  } = useMutation(() => LeavepageService.withdrawLeave(leaveId), {
    onSuccess: () => {
      if (onConfirm) onConfirm();
      setIsSuccess(true);
      setIsOpen(false);
      window.location.reload();
    },
    onError: (err: any) => {
      console.error(err);
    },
  });

  const handleModalClose = () => {
    setIsOpen(false);
    if (onClose) onClose();
  };

  const handleConfirm = () => {
    if (isLoading) return;
    withdrawLeave();
  };

  useEffect(() => {
    if (isSuccess) {
    }
  }, [isSuccess, navigate]);

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={handleModalClose}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '700px',
          height: '270px',
          display: 'flex',
          flexDirection: 'column',
          padding: '0 40px 0 40px',
          background: '#F3F4F8',
          overflowY: 'hidden',
        },
      }}
    >
      <ReopenTicketHeader>
        <div style={{ marginTop: '30px' }}>
          <CloseIcon src={closeSvg} onClick={handleModalClose} />
        </div>
      </ReopenTicketHeader>

      <ReopenTicketBody>
        <ReopenQues>
          <p>Are you sure you want to withdraw your leave?</p>
        </ReopenQues>

        <ReopenFooter>
          <RegularButton type="button" style={{ color: '#4948AC', backgroundColor: '#fff' }} onClick={handleModalClose}>
            {t('global.form.cancel')}
          </RegularButton>

          <RegularButton
            type="button"
            style={{ backgroundColor: 'rgb(72 71 171)', color: '#fff' }}
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Withdrawing...' : 'Withdraw'}
          </RegularButton>
        </ReopenFooter>
      </ReopenTicketBody>

      {isError && <p>Error: {error?.message}</p>}
    </ReactModal>
  );
};
